import React, { useLayoutEffect, useState } from 'react'
import { useRef } from 'react'
import { Button } from 'ui'
import {
  Container,
  Content,
  Header,
} from './styles'
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg'
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg'
import { Card } from '..'
import { Text } from 'ui/index'
import useResponsive from 'utils/hooks/useResponsive'

const Faq = ( { title, children }) => {

  const [isOpen, setIsOpen] = useState(false)
  const { isTab } = useResponsive()


  const containerRef = useRef()
  const headerRef = useRef()
  const contentRef = useRef()

  const handleOpen = () => setIsOpen(prev => !prev)

  const setContainerHeight = () => {
    const { height: contentHeight } = contentRef.current.getBoundingClientRect()
    const { height: headerHeight } = headerRef.current.getBoundingClientRect()

    containerRef.current.style.height = isOpen
    ? `${headerHeight + contentHeight}px`
    : `${headerHeight}px`
  }

  const currentChildren = typeof children === 'function'
    ? children
    : <Text size={isTab ? 'sm' : 'base'}>{children}</Text>

  useLayoutEffect(() => {
    containerRef.current.style.transition = 'height 400ms'
    setContainerHeight()
  }, [isOpen])

  useLayoutEffect(() => {
    const resizing = () => {
      containerRef.current.style.transition = 'height 0ms'
      setContainerHeight()
    }

    window.addEventListener('resize', resizing)

    return () => window.removeEventListener('resize', resizing)
  }, [isOpen])

  return (
    <Card marginBottom={24}>
      <Container ref={containerRef}>
        <Header ref={headerRef} onClick={handleOpen}>
          <Text size={isTab ? 'xl' : '2xl'} color='headline'>{title}</Text>
          <Button variant='icon' size='small'>
            { isOpen
                ? <ChevronUp height={16} width={16} />
                : <ChevronDown height={16} width={16} />
            }
          </Button>
        </Header>

        <Content ref={contentRef}>
          {currentChildren}
        </Content>
      </Container>
    </Card>
  )
}

export default Faq